module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-toaster"
  }, [_c('transition-group', {
    attrs: {
      "name": "v-toast"
    }
  }, _vm._l((_vm.items), function(t) {
    var _obj;

    return _c('div', {
      key: t.key,
      staticClass: "v-toast",
      class: ( _obj = {}, _obj[t.theme] = t.theme, _obj )
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "message-header",
      attrs: {
        "sm12": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v(_vm._s(t.icon))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(t.title))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(t)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "message-body",
      attrs: {
        "sm12": ""
      },
      domProps: {
        "innerHTML": _vm._s(t.message)
      }
    })], 1)], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ac9faa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/plugins/message/AppMessages.vue
// module id = 496
// module chunks = 2